import { useTranslation } from 'react-i18next';
import RegistrationForm from '../RegistrationForm/RegistrationForm';
import type { BannerContentProps } from './bannerContentRegistry';

const BlackFridayPromoBannerContent = ({
    promoCode,
    buttonText
}: BannerContentProps) => {
    const { t } = useTranslation();

    return (
        <div className="promo-banner__black-friday-container">
            <div className="promo-banner__pills-container">
                <span className="promo-banner__pill promo-banner__pill--black-friday">
                    {t('black25.banner.pill1') as string}
                </span>
                <span className="promo-banner__pill promo-banner__pill--sale">
                    {t('black25.banner.pill2') as string}
                </span>
                <span className="promo-banner__pill promo-banner__pill--last-chance">
                    {t('black25.banner.pill3') as string}
                </span>
            </div>
            <div className="promo-banner__text-container-black-friday">
                <div className="promo-banner__main-text">
                    {t('black25.banner.mainText') as string}
                    <span className="promo-banner__cta-link">
                        {t('black25.banner.ctaText') as string}
                    </span>
                    <span className="promo-banner__cta-link-suffix">
                        {t('black25.banner.ctaTextSuffix') as string}
                    </span>
                </div>
                <div className="promo-banner__terms-text">
                    {t('black25.banner.terms') as string}
                </div>
            </div>
            <RegistrationForm
                customClass="promo-banner-cta"
                buttonStyle="invisible"
                source="banner"
                buttonText={buttonText}
                couponCode={promoCode}
                size="x-small"
            />
        </div>
    );
};

export default BlackFridayPromoBannerContent;

